module.exports = __webpack_public_path__ + "static/img/solu2.758cebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Solution/img/solu2.jpg
// module id = 6XXp
// module chunks = 1